import React, { useState } from 'react';
import Header from '../components/Header';
import CustomFooter from '../components/Footer';
import { createTeam } from '../api/team_stuff';
import { useNavigate } from 'react-router-dom';

const CreateTeam = () => {
    const [formValues, setFormValues] = useState({ teamname: '', teamorg: '' });
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});

        const validationErrors = {};
        if (!formValues.teamname.trim()) validationErrors.teamname = "Team name is required.";
        if (!formValues.teamorg.trim()) validationErrors.teamorg = "Team organization is required.";

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            const response = await createTeam(formValues);
            let teamnamevalue = formValues.teamname;  
            //alert(teamnamevalue);                    
            if(response.status === "success"){
                setFormValues({ teamname: '', teamorg: '' }); // Clear form 
                navigate(`/team/${encodeURIComponent(teamnamevalue)}`);
            }
            //alert("Team created successfully!");           
        } catch (error) {
            console.error("Error creating team:", error);
            alert("Failed to create team. Please try again.");
        }
    };

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            <Header />
            <div className="flex-grow container mx-auto p-4">
                <h2 className="text-2xl font-bold mb-4">Create Team</h2>
                <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-md">
                    {[
                        { label: "Team Name", name: "teamname" },
                        { label: "Organization Name", name: "teamorg" },
                    ].map(({ label, name }) => (
                        <div className="form-group mb-4" key={name}>
                            <label htmlFor={name} className="block text-gray-700">{label}</label>
                            <input
                                type="text"
                                id={name}
                                name={name}
                                value={formValues[name]}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded p-2"
                            />
                            {errors[name] && <div className="text-red-500 text-sm">{errors[name]}</div>}
                        </div>
                    ))}

                    <div className="form-group">
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700"
                        >
                            Create Team
                        </button>
                    </div>
                </form>
            </div>
            <CustomFooter />
        </div>
    );
};

export default CreateTeam;
